import React from 'react';
import { useVonjoModal } from '../../../../utils/vonjo_modal_context';
import styles from './index.module.css';

const VonjoModal = ({}) => {
  const { isModalVisible } = useVonjoModal();

  if (!isModalVisible) return null;

  return (
    <div className={`${styles.vonjo_modal_container} platform-modal container-fluid`}>
      <div className={`${styles.v_modal}`}>
        <div className={styles.modal_body_wrap}>
          <div className={`${styles.vonjo_modal_banner}`}>
            <p className={`${styles.nb_para}`}>Thank you!</p>
          </div>
          <div className={styles.whats_next}>What's next?</div>

          <div className={`${styles.content}`}>
            Thank you for requesting a call with your mentor! We will contact you shortly to schedule a time. During the
            call, you can learn how they cope with their disease, hear about their disease experience, and understand
            their treatment journey.
          </div>
          <div className={`${styles.content}`}>
            If you would like to contact us directly, please email us at{' '}
            <a className={styles.contact_link} href='mailto:info@patientpartner.com'>
              info@patientpartner.com
            </a>{' '}
            or call us at{' '}
            <a className={styles.contact_link} href='tel:6192681112'>
              619-268-1112
            </a>
            .
          </div>
        </div>
      </div>
    </div>
  );
};

export default VonjoModal;
